import type { CreateAccountInfoServiceRequest } from '@musinsa/services-curator';
import type { SettlementFormData } from '../../../settlement/components/SettlementInfoForm/types';

const isFileLike = (value: unknown): value is File | Blob => {
  if (typeof File !== 'undefined' && value instanceof File) {
    return true;
  }

  if (typeof Blob !== 'undefined' && value instanceof Blob) {
    return true;
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  const maybeFile = value as { size?: unknown; type?: unknown };
  return typeof maybeFile.size === 'number' && typeof maybeFile.type === 'string';
};

const toOptionalFile = (value: unknown) => (isFileLike(value) ? value : undefined);

const toOptionalString = (value?: string | null) => {
  if (value == null) {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

/**
 * UI 폼 데이터를 Service Layer 요구 형식으로 변환
 */
export const transformSettlementDataToServiceRequest = (
  formData: SettlementFormData,
): CreateAccountInfoServiceRequest => ({
  businessType: formData.businessType,
  idNumberFirst: toOptionalString(formData.idNumberFirst),
  idNumberSecond: toOptionalString(formData.idNumberSecond),
  identityFile: toOptionalFile(formData.identityFile),
  businessName: toOptionalString(formData.businessName),
  businessRegistrationNumber: toOptionalString(formData.businessRegistrationNumber),
  businessLicenseFile: toOptionalFile(formData.businessLicenseFile),
  bankName: toOptionalString(formData.bankName),
  accountNumber: toOptionalString(formData.accountNumber),
  accountHolder: toOptionalString(formData.accountHolder),
  accountCopyFile: toOptionalFile(formData.accountCopyFile),
  termsAgreed: formData.termsAgreed,
});
